import { Pipe, PipeTransform } from '@angular/core';
import { Beneficiaire } from '../../models/beneficiaire';
import { Prestation } from '../../models/prestation';

@Pipe({
	name: 'filterPrestation'
})
export class FilterPrestationPipe implements PipeTransform {
	transform(prestation: Prestation[], filter: string, applyFilter: boolean): Prestation[] {
		if (!applyFilter || 
			!prestation ||
			!filter ||
			prestation === null ||
			filter === null ||
			filter === ''
		) {
			return prestation;
		}

		return prestation.filter((prestation: Prestation) => {
			if (prestation.beneficiaire && prestation.intervenant) {
				// TODO: add lastName too
				return prestation.numeroCommande?.toLowerCase().includes(filter.toLowerCase()) ||
				prestation.beneficiaire.lastName?.toLowerCase().includes(filter.toLowerCase()) || 
				prestation.beneficiaire.firstName?.toLowerCase().includes(filter.toLowerCase()) || 
				prestation.intervenant.lastName?.toLowerCase().includes(filter.toLowerCase()) || 
				prestation.intervenant.firstName?.toLowerCase().includes(filter.toLowerCase());
			}
			return false;
		});
	}
}
